import { ENABLE_STUDIO_COMMUNITY_HEADER } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

export const useStudioCommunityHeader = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isStudioCommunityHeaderEnabled = experiments.enabled(
    ENABLE_STUDIO_COMMUNITY_HEADER,
  );

  return { isStudioCommunityHeaderEnabled };
};
